import type { SubmitFeedbackRequest } from '@clockwise/clients/feedback';
import { useMutation } from '@tanstack/react-query';
import { feedbackApi } from '@/lib/api';

/**
 * Hook for the in-app feedback widget. Fire-and-forget — there is no
 * server-side persistence, just an email to the addresses configured
 * via `FEEDBACK_RECIPIENTS` on the api.
 */
export function useSubmitFeedback() {
  return useMutation({
    mutationFn: ({
      payload,
      attachments,
    }: {
      payload: SubmitFeedbackRequest;
      attachments?: File[];
    }) => feedbackApi.submit(payload, attachments),
  });
}
